module.exports = __webpack_public_path__ + "img/alex-awake-face.94b0e99c.png";